import ChartRepository from "../domain/data/ChartRepository";
import { CampaignChart } from "../domain/entities/Chart";
import User from "../domain/entities/User";

export default class MockChartRepository implements ChartRepository {
  async getCampaignChart(user: User): Promise<CampaignChart[]> {
    throw new Error("Method not implemented.");
  }
}
